import { useEffect, useState } from 'react';

const navItems = [
  { id: 'download', label: '下载方式' },
  { id: 'address', label: '最新地址' },
  { id: 'features', label: '功能特色' },
  { id: 'install', label: '安装步骤' },
  { id: 'devices', label: '兼容设备' },
  { id: 'changelog', label: '更新记录' },
  { id: 'faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8">
        <div className="h-16 md:h-20 flex items-center justify-between">
          <a
            href="#top"
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => setOpen(false)}
          >
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-lg ${
                scrolled || open ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
              }`}
            >
              <i className="ri-play-fill text-xl"></i>
            </span>
            <span
              className={`font-heading text-xl tracking-wide ${
                scrolled || open ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              啪啪视频
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`px-3 py-2 text-sm rounded-md cursor-pointer transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <a
              href="#download"
              className="hidden sm:inline-flex items-center gap-1 px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              立即下载
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
                scrolled || open
                  ? 'text-foreground-950 hover:bg-background-200'
                  : 'text-background-50 hover:bg-background-50/10'
              }`}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-4 grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm rounded-md bg-background-100 text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}